import { Label } from 'components/';
import styled from 'styled-components';
import { bold } from 'design-system/style-mixins/text';
import { black } from 'design-system/variables/colors';

export const BoldLabel = styled(props => <Label {...props} />)`
	${bold};
	color: ${black};
`;
